import {Parameter} from 'platform/components';

import {Nullish} from 'shared/web';

import {EmailWithWarning} from '../components/EmailWithWarning/EmailWithWarning';
import {isInvalidEmail} from './isInvalidEmail';

/** A stored e-mail as a parameter; an e-mail the DMS API refuses shows a warning and no action. */
export const getEmailParameter = (email: string | Nullish): Parameter =>
  isInvalidEmail(email)
    ? {title: email, content: <EmailWithWarning email={email} data-testid="storedEmail" />}
    : email;
